import { render, staticRenderFns } from "./SectionReference.vue?vue&type=template&id=b1980e52&scoped=true"
import script from "./SectionReference.vue?vue&type=script&lang=js"
export * from "./SectionReference.vue?vue&type=script&lang=js"
import style0 from "./SectionReference.vue?vue&type=style&index=0&id=b1980e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1980e52",
  null
  
)

export default component.exports